import { callApi } from "./index"

export const getRegions = (): Promise<StateRegion[]> => {
  return callApi("/api/easydirectoryapi/get-regions-grouped", { })
}

export interface StateRegion {  
    StateId: number
    StateName: string    
    Regions: Region[]
}

export interface Region {
  Id: number
  Name: string
  ShortName: string
  Slug: string
}

export const getDestinationWeddingRegions = (): Promise<IDestinationWeddingRegion[]> => {
  return callApi("/api/easydirectoryapi/get-dw-regions", { })
}

export interface IDestinationWeddingRegion {
  Id: number,
  Name: string,
  DisplayOrder: string,
}
